import React from 'react'
import { DayforcePanelProvider } from './context/DayforcePanelProvider'
import { DayforcePanelMain } from './components/DayforcePanelMain'
import { useShiftDetailContextValue } from '../../context/ShiftDetailProvider'

export const DayforcePanel = () => {
  const {
    state: { dayforceAgencyId, dayforceJobId, dayforceBookingId },
  } = useShiftDetailContextValue()

  if (!dayforceAgencyId || !dayforceJobId || !dayforceBookingId) {
    return null
  }

  return (
    <DayforcePanelProvider>
      <DayforcePanelMain />
    </DayforcePanelProvider>
  )
}
